import axios from 'axios'

const adminApiUrl = `${process.env.REACT_APP_API_BASE_URL}/api/v1/admin`

const authInstance = axios.create({
  baseURL: `${adminApiUrl}/auth`,
  headers: {
    'Content-Type': 'application/json',
  },
})

export const axiosAuthInstance = async (url, values) => {
  //eslint-disable-next-line no-useless-catch
  try {
    const response = await authInstance.post(url, values)
    return response
  } catch (error) {
    throw error
  }
}

export default axiosAuthInstance
